import React from 'react';
import styles from './CurrentPlanCard.module.scss';

interface CurrentPlanCardProps {
  seasonalPrice: number;
}

const CurrentPlanCard = ({ seasonalPrice }: CurrentPlanCardProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.flexColumn}>
        <h4 className={styles.planText}>Seasonal</h4>
        <p>Your current plan</p>
      </div>
      <p className={styles.price}>${seasonalPrice}/Box</p>
    </div>
  );
};

export { CurrentPlanCard };
